import { ApolloLink, Observable } from '@apollo/client';
import { startSinaBusy } from '@/components/SinaAssistant/sinaBusy.js';

function isMutation(operation) {
  return operation?.query?.definitions?.some(
    (definition) => definition?.kind === 'OperationDefinition' && definition?.operation === 'mutation',
  );
}

/** Mantiene a Sina "en camino" mientras haya una mutación GraphQL en vuelo. */
export function createSinaBusyLink() {
  return new ApolloLink((operation, forward) => {
    if (!isMutation(operation)) return forward(operation);
    return new Observable((observer) => {
      const release = startSinaBusy();
      const subscription = forward(operation).subscribe({
        next: (value) => observer.next(value),
        error: (error) => { release(); observer.error(error); },
        complete: () => { release(); observer.complete(); },
      });
      return () => { release(); subscription.unsubscribe(); };
    });
  });
}
